import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/actions/userActions';
import { useNavigate } from 'react-router-dom';

export const useTokenExpiration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const expiresAt = localStorage.getItem('expiresAt');
    const token = localStorage.getItem('token');

    if (!expiresAt || !token) return;

    const expiresIn = Number(expiresAt) - Date.now();

    if (expiresIn <= 0) {
      // Already expired
      dispatch(logout());
      navigate('/login');
      return;
    }

    // Set timeout to logout when token expires
    const timeout = setTimeout(() => {
      dispatch(logout());
      navigate('/login');
    }, expiresIn);

    return () => clearTimeout(timeout);
  }, [dispatch, navigate]);
};
